import { connect, MapStateToProps } from 'react-redux'
import { loadConfigurationByVehicleCode } from '../../redux/actions/app/vehicleCode.actions'
import { Props } from './EnterVehicleCodeModalWrapper'
import brandSelector from '../../redux/selectors/brandSelector'
import { loadConfigurationByVin } from '../../redux/actions/app/vin.actions'
import isVehicleCodeEnabledSelector
    from '../../redux/selectors/feature-scope/isVehicleCodeEnabledSelector'
import isVinEnabledSelector from '../../redux/selectors/feature-scope/isVinEnabledSelector'

type StateProps = Pick<Props, 'brand' | 'vehicleCodeEnabled' | 'vinEnabled'>

const mapStateToProps: MapStateToProps<StateProps, {}> = (state) => ({
    brand: brandSelector(state),
    vehicleCodeEnabled: isVehicleCodeEnabledSelector(state),
    vinEnabled: isVinEnabledSelector(state),
})

type DispatchProps = Pick<Props, 'submitVehicleCode' | 'submitVin'>

const mapDispatchToProps: DispatchProps = {
    submitVehicleCode: loadConfigurationByVehicleCode,
    submitVin: loadConfigurationByVin,
}

export default connect(mapStateToProps, mapDispatchToProps)
